/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RedirectAliases {
  LAYOUT_REDIRECT = 'layout-redirect',
  LOADER_0 = 'loader-0',
  PANEL_0 = 'panel-0',
}
export { RedirectAliases };
